// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"f225479e","140":"c52698ae","453":"578fd3f8","682":"3222dd1e","795":"b6ce102f","798":"abf3a134","828":"c587c6fd","834":"2f18e65d"}[chunkId] + ".chunk.js";
};